import { connect } from "react-redux";
import React, { useState } from "react";

import PostSessionsSurveyConfirmation from "./PostSessionsSurveyConfirmation";
import PostSessionSurvey from "./PostSessionSurvey";
import PostSessionSurveyTutorial from "./PostSessionSurveyTutorial";

const PostSessionSurveyContainer = (props) => {
  let initalStep = "postSessionSurveyTutorial";

  if (props.profile.pss_tutorial) {
    initalStep = "postSessionSurvey";
  }
  const [activeStep, setActiveStep] = useState(initalStep);

  const steps = {
    postSessionsSurveyConfirmation: <PostSessionsSurveyConfirmation />,
    postSessionSurvey: (
      <PostSessionSurvey
        {...props}
        submit={() => setActiveStep("postSessionsSurveyConfirmation")}
      />
    ),
    postSessionSurveyTutorial: (
      <PostSessionSurveyTutorial {...props} submit={() => setActiveStep("postSessionSurvey")} />
    ),
  };

  return <>{steps[activeStep]}</>;
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps)(PostSessionSurveyContainer);
